import { render, staticRenderFns } from "./authorizationMsg.vue?vue&type=template&id=9ea4de2e&scoped=true"
import script from "./authorizationMsg.vue?vue&type=script&lang=js"
export * from "./authorizationMsg.vue?vue&type=script&lang=js"
import style0 from "./authorizationMsg.vue?vue&type=style&index=0&id=9ea4de2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ea4de2e",
  null
  
)

export default component.exports